<template>
  <div
    class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-16 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">
            New user
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit user</div>
        </div>
      </div>

      <div class="relative">
         <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <div class="bg-white rounded-lg p-6">
          <div class="grid lg:grid-cols-2 gap-6">
            <div
             
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="fullName" class="bg-white text-gray-700 px-1"
                    >Full Name *</label
                  >
                </p>
              </div>
              <p>
                <input
                  id="fullName"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.fullName"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
            <div
              v-if="formData._id"
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="phone" class="bg-white text-gray-700 px-1"
                    >Phone *</label
                  >
                </p>
              </div>
              <p>
                <input
                  id="phone"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.phone"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
            <div
              v-if="formData._id"
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="username" class="bg-white text-gray-700 px-1"
                    >Username *</label
                  >
                </p>
              </div>
              <p>
                <input
                  id="username"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.username"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                  @keydown.space="(event) => event.preventDefault()"
                />
              </p>
            </div>

            <div
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="name" class="bg-white text-gray-700 px-1"
                    >Email *</label
                  >
                </p>
              </div>
              <p>
                <input
                  required
                  autocomplete="false"
                  tabindex="0"
                  type="email"
                  v-model="formData.email"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"
                />
              </p>
            </div>

            <div
              v-if="formData._id"
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="lastname" class="bg-white text-gray-700 px-1"
                    >Store *</label
                  >
                </p>
              </div>
              <p>
                <input
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.company"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
             <div
              v-if="formData._id"
              class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="lastname" class="bg-white text-gray-700 px-1"
                    >RIB *</label
                  >
                </p>
              </div>
              <p>
                <input
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.rib"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>

            <div
              class="border h-10 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="name" class="bg-white text-gray-700 px-1"
                    >Role *</label
                  >
                </p>
              </div>
              <p>
                <select
                  autocomplete="type"
                  v-model="formData.role"
                  :disabled="!$f.getAccessPermission(currentUser,'users','create')"
                  @change="onChangeRole(formData.role)"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                >
                  <option selected disabled :value="null">Role</option>
                  <option v-for="role in roles" :key="role._id" :value="role">
                    {{ role.type }}
                  </option>
                </select>
              </p>
            </div>

            <div
              v-if="formData._id && formData.type === 'Seller' && currentUser.type !== 'Seller'"
              class="border focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="payment" class="bg-white text-gray-700 px-1"
                    >Account Manager</label
                  >
                </p>
              </div>
              <p>
                <v-select label="fullName" v-model="formData.accountManagers" :options="accountManagers" multiple></v-select>
              </p>
            </div>
             <!-- coutries -->
            
            <div class="w-full">
                  <div class="flex justify-center items-center">
                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current mr-2"><path  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"></path></svg>
                    <div  class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="Countries" class="bg-white text-gray-700 px-1"> Warehouses *</label>
                        </p>
                      </div>    
                      <p>
                        <v-select :disabled="!formData.role?true:false" label="countryName" @input="setSelectedW" v-model="formData.warehouses" :options="warehouses" multiple>
                                <template slot="option" slot-scope="option">
                                    <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                    {{ option.countryName }} 
                                </template>
                          </v-select>
                      </p>         
                   </div>  
                  </div>
                
                  <span v-if="checkWarehousingParent.length>0 && formData.role && ['Seller', 'Admin','Administrateur','Subscription','AccountManager'].indexOf(formData.role.type||this.formData.type) == -1" class="ware_prin">
                    
                    <div  class="border mll-4 hover:border-blue-400  w-10/12 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">Zone (City)
                          <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                    <p>
                      <v-select  v-model="formData.sous_warehouses" :options="checkWarehousingParent" multiple label="name"></v-select>
                    </p>
                  </div>
                  </span >
            </div>

            <div
              v-if="formData._id && formData.type === 'Seller' && currentUser.type !== 'Seller' && formData.warehouses.length>0"
              class="border focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="payment" class="bg-white text-gray-700 px-1">Disabled confirmation</label
                  >
                </p>
              </div>
              <p>
                <v-select label="name" v-model="formData.disabledConfermation" :options="warehouses" multiple></v-select>
              </p>
            </div>

            <div
              v-if="formData._id && formData.type === 'Seller' && currentUser.type !== 'Seller' && formData.warehouses.length>0"
              class="border focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="payment" class="bg-white text-gray-700 px-1">Status order can update</label
                  >
                </p>
              </div>
              <p>
                <v-select label="name" v-model="formData.statusToUpdate" class="capitalize" :options="['pending->confirmed','pending->cancelled','cancelled->confirmed']" multiple></v-select>
              </p>
            </div>
            <!-- /coutries -->

            <!-- <div
              v-if="livreur && selectedRole == livreur"
              class="border hover:border-blue-400 mt-4 px-4 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="description" class="bg-white text-gray-700 px-1"
                    >Select Zones
                    <span :class="$colors.required">*</span></label
                  >
                </p>
              </div>
              <div class="">
                <div class="w-full mt-2">
                  <table class="table w-full text-center table-zone">
                    <thead class="bg-gray-100 text-black">
                      <tr>
                        <th
                          class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                        >
                          Zones
                        </th>

                        <th
                          class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                        ></th>
                        <th
                          class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                        >
                          Add
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in zones"
                        :key="index"
                        :class="index % 2 == 0 ? 'bg-gray-100' : ''"
                      >
                        <td
                          class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                        >
                          <p class="text-gray-700 capitalize">
                            {{ item.name }}
                          </p>
                        </td>

                        <td
                          class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                        ></td>
                        <td
                          class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                        >
                          <p
                            class="text-gray-600 ml-3 text-semibold capitalize"
                          >
                            <label
                              class="inline-flex text-sm items-center capitalize"
                            >
                              <input
                                @change="addZones(item)" @click="getRowDetail(item._id)"
                                v-model="item.check" 
                                type="checkbox" :id="item._id"
                                class="form-checkbox rowCheckbox border-gray-500 h-4 w-4 text-blue-500"
                              />
                            </label>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> -->
          </div>
          <!--fees seller -->
          <div v-if="formData._id && formData.type=='Seller'">
            <div class="flex mt-10 mb-5 items-center text-center">
                <hr class="border-gray-300 border-1 w-full rounded-md">
                <label @click="Showfees" class="block font-medium text-sm cursor-pointer text-blue-500 w-full">Fees seller <i class="material-icons" style="transition: 0.3s" :style="showMoreInfo? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i></label>
                <hr class="border-gray-300 border-1 w-full rounded-md">
            </div>
            <div  v-if="showMoreInfo" class="flex flex-wrap">
              <div class="w-full lg:w-3/12 px-4 mt-5">
                <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                        <label class="bg-white text-gray-700 px-1" for="grid-password">Confirmaion fees</label>
                      </p>  
                  </div>
                    <p>
                      <input type="number" v-model="fees.confirmation" min="0" class="py-2 text-xs px-2 outline-none block h-full w-full">
                  </p>   
                </div>
              </div>
               <div class="w-full lg:w-3/12 px-4 mt-5">
                <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                        <label class="bg-white text-gray-700 px-1" for="grid-password">Order fees</label>
                      </p>  
                  </div>
                    <p>
                      <input type="number" v-model="fees.order_fees" min="0" class="py-2 text-xs px-2 outline-none block h-full w-full">
                  </p>   
                </div>
              </div>
              <div class="w-full lg:w-3/12 px-4 mt-5">
                <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label class="bg-white text-gray-700 px-1" for="grid-password">Shipping fees</label>
                      </p>  
                  </div>
                    <p>
                      <input type="number" v-model="fees.shipping" min="0" class="py-2 text-xs px-2 outline-none block h-full w-full">
                    </p>  
                </div>
              </div>
              <div class="w-full lg:w-3/12 px-4 mt-5">
                <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                        <label class="bg-white text-gray-700 px-1" for="grid-password">Shipping refund</label>
                    </p>  
                  </div>
                    <p>
                      <input type="number" v-model="fees.refund" min="0" class="py-2 text-xs px-2 outline-none block h-full w-full">
                    </p>       
                </div>
              </div>
              <div class="w-full lg:w-3/12 px-4 mt-5">
                <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p>
                        <label class="bg-white text-gray-700 px-1" for="grid-password">Shipping change</label>
                    </p>   
                  </div>
                    <p>
                      <input type="number" v-model="fees.change" min="0" class="py-2 text-xs px-2 outline-none block h-full w-full">
                    </p>  
                </div>
              </div>
            </div>
          </div>
          <!--/ fees seller -->
          <div class="mt-6 pt-3 pb-4 flex justify-center">
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
              :disabled="loading"
              @click="save"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
        category: null,
        role: null,
        zones: [],
        warehouses:[],
        sous_warehouses:[],
        fees:[],
        type: "",
      },
      fees:{
        change: -1,
        confirmation: -1,
        order_fees:-1,
        refund: -1,
        shipping: -1,
      },
      roles: [],
      zones: [],
      warehouses:[],
      currentZone:[],
      allZones:[],
      loading:false,
      fullPage: false,
      types: [
        "Seller",
        "TeleConsultant",
        "StockManager",
        "Courier",
        "Accountant",
        "Admin",
        "Administrateur",
        "CallenterManager",
        "NRP",
        "AccountManager"
      ],
      categories: [],
      livreur: "",
      selectedRole: "",
      tempZones: [],
      checkbox:true,
      showMoreInfo:false,
      checkWarehousingParent:[],
      accountManagers:[]
    };
  },

  async mounted() {
    await this.getWarehouses();
    await this.getRoles();
   // await this.getZones();
    await this.dataToEdit();
   // await this.getRoleByType();
  },
  computed: {
     warhouseSelected(){
       return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
    },
  },
  watch: {
      'warhouseSelected': async function(oldVal, newVal) {
           // await this.getwharhouseId();
            //await this.dataToEdit();
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.dataToEdit();
      }
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    validateEmail(email) {
      // Regular expression pattern for valid email address
       const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
       // Check if email matches the pattern
       return pattern.test(email);
    },
    async setSelectedW(warhouse){
      console.log('warhouse------------',warhouse)
      console.log('role------------',this.formData)
      console.log("['Seller', 'Admin','Administrateur','Subscription']",['Seller', 'Admin','Administrateur','Subscription'].indexOf(this.formData.role.type))
         this.checkWarehousingParent=this.formData.sous_warehouse=[];
         if (warhouse && warhouse.length>0 && this.formData.role && ['Seller', 'Admin','Administrateur','Subscription','AccountManager'].indexOf(this.formData.role.type) == -1) {
          console.log('country 11------------',warhouse[0].country)
            await this.getWarehousingParent(warhouse[0].country); 
          }
      },
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    async getWarehouses(){
        if(this.currentUser && this.currentUser.type){
          if(this.currentUser.type == 'Admin'){
              const filter = {limit:1000};
              const res = await this.$server.search("warehouses",filter);
              if (res && res.content.results) this.warehouses = res.content.results;
              else this.warehouses = [];
          }else this.warehouses=this.currentUser.warehouses;
        }  
    }, 
    async getUser() {
      const res = await this.$server.me("users");

      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    Showfees() {
      this.showMoreInfo =  !this.showMoreInfo ;
    },
    async save() {
      if (this.formData._id) {
        if(this.formData.warehouses.length==0){
          alert(`Please select warehouse`, "warning");
          return false
        }
        if(['Seller', 'Admin','Administrateur','Subscription','AccountManager'].indexOf(this.formData.type) == -1){
            if(this.formData.warehouses.length>1)  {alert(`Le rôle ${this.formData.type} peu contient un seul warehouse !`, "warning");return false;}
            if(this.checkWarehousingParent.length>0 && this.formData.sous_warehouses.length==0) {alert(`Sous warehouse (Zones) required !`, "warning");return false;}  
           // if(this.formData.sous_warehouses.length>1)  {alert(`Le rôle ${this.formData.type} peu contient un seul sous warehouse !`, "warning");return false;}
        }else {this.formData.sous_warehouses=this.checkWarehousingParent=[];}
        
        let currentSettingW=null;
        if(this.formData.fees.length && this.formData.fees[0].warehouse) currentSettingW=this.$f.getElementInArray(this.formData.fees,this.idWharhouse);
        if(currentSettingW) this.$f.changeDataWarhouse(this.formData.fees,this.idWharhouse._id,this.fees);
        else {
          this.fees.warehouse=this.idWharhouse;
          this.formData.fees.push(this.fees);
        }
        if(!this.validateEmail(this.formData.email)){
            alert('Please enter a valid email address', "warning");
            this.loading=false;
            return false;
          }
          
        this.formData.email=this.formData.email.toLowerCase().trim();
        this.loading=true;
        const data = await this.$server.update("users", this.formData);
        this.loading=false;
        if (data && data._id) {
            await this.dataToEdit();
            alert("User updated", "success");
        }else  alert(data.content||data, "warning");
      } else {

        if(!this.formData.role) alert(`Please select user role !! `, "warning");
        else{

          if(['Seller', 'Admin','Administrateur','Subscription','AccountManager'].indexOf(this.formData.type) == -1){
            if(this.formData.warehouses.length>1)  {alert(`Le rôle ${this.formData.type} peu contient un seul warehouse !`, "warning");return false;}
            if(this.checkWarehousingParent.length>0 && this.formData.sous_warehouses.length==0) {alert(`Sous warehouse (Zones) required !`, "warning");return false;} 
           // if(this.formData.sous_warehouses.length>1)  {alert(`Le rôle ${this.formData.type} peu contient un seul sous warehouse !`, "warning");return false;} 
          }else {this.formData.sous_warehouses=this.checkWarehousingParent=[];}
          //return false

          this.formData.type = this.formData.role.type;
       
        if (this.checkData()) {
          if(!this.validateEmail(this.formData.email)){
            alert('Please enter a valid email address', "warning");
            this.loading=false;
            return false;
          }
            this.formData.role = this.selectedRole;
            this.formData.email=this.formData.email.toLowerCase().trim();
            this.loading=true;
            const data = await this.$server.create("users", this.formData);
            this.loading=false;
          console.log('data________________________________',data)
            if (data && data._id) {
            alert("User created !", "success");
            this.formData = {
              role: null,
              zones: [],
              warehouses:[],
              sous_warehouses:[],
            };
            this.checkWarehousingParent=[];
              // for (let i = 0; i <this.zones.length; i++) {
              //     this.zones[i].check='';
              // } 
          }else alert(data.content||data, "warning");
        } else  alert(`you must fill all the fields !! `, "warning");
      }
      }
    },
    getRowDetail(zone_id){
       let itemInRow = this.formData.zones.filter(item => item === zone_id);
            let isItemInRow = itemInRow.length > 0;
                
        if (isItemInRow) { 
            let pos = this.formData.zones.map(function (e) {
                return e;
            }).indexOf(zone_id);
            this.formData.zones.splice(pos, 1);
        } else {
            this.formData.zones.push(zone_id);
        }
    },
    checkData() {
      if (this.formData.role && this.formData.fullName && this.formData.email && this.formData.type && this.formData.warehouses.length>0)
        return true;
      else return false;
    },
    async getRoleByType() {
      const filter = {
        type: "Courier",
      };
      const res = await this.$server.get("roles", filter);
      this.livreur = res.content._id;
    },
    async onChangeRole(data) {
      this.formData.type=data.type;
      this.selectedRole = data._id;
      console.log('type------------',data.type)
      if(data && data.type == 'Courier') {
        await this.getRoleByType();
       // await this.getZones();
      }
      console.log('warehouses------------',this.formData.warehouses)
      console.log('warehouses ww------------',this.formData.warehouses.length)
      console.log('chck ww------------', ['Seller','Admin','Administrateur','Subscription'].indexOf(data.type))
      if(data && ['Seller','Admin','Administrateur','Subscription','AccountManager'].indexOf(data.type) == -1 && this.formData.warehouses && this.formData.warehouses.length==1) {
        console.log('is detected')
        await this.getWarehousingParent(this.formData.warehouses[0].country); 
      }else {this.checkWarehousingParent=this.formData.sous_warehouse=[];}
    },
    async getWarehousingParent(country) {
          console.log('country-----',country)
          const resW = await this.$server.search("warehouses", { country: country,all:true,limit:100}); 
          console.log('resW-----',resW.content)
          if(resW.content && resW.content.results) {
              this.checkWarehousingParent=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
          }else this.checkWarehousingParent=[];
    },
    addZones(item) {
      if (item.check) {
        const zone = {
          _id: item._id,
        };
        this.tempZones.push(zone);
      } else {
        let pos = this.tempZones
          .map(function (e) {
            return e._id;
          })
          .indexOf(item._id);
        this.tempZones.splice(pos, 1);
      }
    },
    async getUsers(role) {
      const filter = {
        type: role,
        limit:300,
      };
      const res = await this.$server.search("users", filter);
      if (res && res.content.results) this.accountManagers = res.content.results;
      else this.accountManagers = [];
    },
    /******************************************************************************************/
    async dataToEdit() {
      if (this.$route.params.id) {
        this.loading=true;
        const editData = await this.$server.get("users", {id: this.$route.params.id,});
        this.formData = editData.content;
        if(['Seller', 'Admin','Administrateur','Subscription','AccountManager'].indexOf(this.formData.type) == -1) {await this.getWarehousingParent(this.formData.warehouses[0].country); }
        let currentSettingW=null;
        if(this.formData.fees.length && this.formData.fees[0].warehouse) currentSettingW=this.$f.getElementInArray(this.formData.fees,this.idWharhouse);
       
        if(currentSettingW) this.fees = currentSettingW;
        else this.fees = {change: -1,confirmation: -1,order_fees:-1,refund: -1,shipping: -1} 
       // this.formData.category = this.formData.categories[0];
        this.selectedRole=this.formData.role._id;
        if(this.currentUser.type !== 'Seller' && this.formData.type === 'Seller') await this.getUsers('AccountManager')
        // this.currentZone=this.formData.zones; 
        // for (let j = 0; j <this.currentZone.length; j++) {
        //     for (let i = 0; i <this.allZones.length; i++) {
        //       if(this.zones[i]._id == this.currentZone[j]){
        //           this.zones[i].check=this.zones[i]._id;
        //         }
        //       }
        //     }   
        this.loading=false;      
      }
    },
    async getCategories() {
      const res = await this.$server.search("categories");
      if (res.content.results) this.categories = res.content.results;
      else this.categories = [];
    },

    async getRoles() {
      let filters={limit:1000};
      if(this.currentUser.type && this.currentUser.type == 'Subscription') filters.type="Seller";
      const res = await this.$server.search("roles",filters);
      if (res.content.results) this.roles = res.content.results;
      else this.roles = [];
    },
    async getZones() {
      const res = await this.$server.search("zones",{limit:1000});
     
      if (res.content.results) {
        this.zones = res.content.results;
        
          for (let i = 0; i < this.zones.length; i++) {
              this.allZones.push(this.zones[i]._id);
          } 
        }
      else {this.zones = this.allZones=[]};
    },
  },
};
</script>


<style >
.object {
  width: 300px;
  height: 300px;
  margin-left: 80px;
  opacity: 0;
  background: white;
  border-radius: 5%;
  border-color: #d3d3d3;
  border-width: thin;
  transform: scaleY(0.8) skewX(10deg);
  transform-origin: 50% 0%;
  transition-duration: 0.25s;
}
.button:hover + .object {
  opacity: 1;
  transform: scaleY(1) skewX(0deg);
}
.table-zone{
  display: block;
    height: 500px;
    overflow-y: scroll;
}
</style>


